import React from "react";
import "../App.css";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) => ({
  footer: {
    marginTop: "5em",
    display: "flex",
    flexDirection: "column",
    justifyContent: "top",
    alignItems: "center",
    height: "30vh",
  },
  title: {
    padding: "0.5em",
  },
}));

export default function Footer() {
  const classes = useStyles();

  return (
    <div className={classes.footer}>
      <Typography variant="subtitle2" className={classes.title}>
        Get in touch
      </Typography>
      <div className={classes.title}>
        <a href="mailto:christiaua@icloud.com">
          <img src="assets/email.svg" width="50px" alt="email"></img>
        </a>
        <a href="https://linkedin.com/in/christianac">
          <img src="assets/linkedin.svg" width="50px" alt="linkedin"></img>
        </a>
      </div>
    </div>
  );
}
